import React from 'react';

const BOLD_MARKUP_RE = /\*\*(.+?)\*\*/g;

export const renderBoldMarkup = (text: string): React.ReactNode => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match = BOLD_MARKUP_RE.exec(text);
  let key = 0;

  while (match) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(<strong key={key++}>{match[1]}</strong>);
    lastIndex = match.index + match[0].length;
    match = BOLD_MARKUP_RE.exec(text);
  }
  parts.push(text.slice(lastIndex));

  return parts;
};

export default renderBoldMarkup;
